import { render, staticRenderFns } from "./ViewFlagItemAction.vue?vue&type=template&id=1b1c120c&scoped=true&"
import script from "./ViewFlagItemAction.vue?vue&type=script&lang=js&"
export * from "./ViewFlagItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c120c",
  null
  
)

export default component.exports